import React, {useState, useEffect} from 'react';
import useChannel from './useChannel.js';

import {
  datagrid_current_bulk_action_task_path,
} from '~/routes';

const DatagridBulkActionNotifier = ({datagrid_id}) => {
  const [processing, setProcessing] = useState({status: null, notification_msg: null});

  useChannel(setProcessing, processing, datagrid_id);

  const fetchProcessing = () => {
    jQuery.get(datagrid_current_bulk_action_task_path({datagrid_id}), (res) => {
      setProcessing(res);
    }).fail((err) => {
      console.error(err)
    });
  }

  useEffect(() => {
    fetchProcessing();
  }, [])

  return (<>
    { processing.status == 'processing' &&
      <div className='mt-1 ml-1 mr-1 mb-0 alert alert-info'>{I18n.t('datagrid_processing_bulk_action_info')}</div>
    }
  </>);
};

export default DatagridBulkActionNotifier;
